import ShippingTypesRepository from '@/data/repositories/ShippingTypesRepository';
import { IShippingTypes } from '@/domain/interfaces/IProduct';
import { AxiosResponse } from 'axios';

/** Representa el controlador que maneja los eventos de los casos de uso de los tipos de envio
 * @returns {object} Funciones del controlador
 */
const ShippingTypesController = () => {
  /** Solicita los Tipos de Envio del back
   * @returns {IShippingTypes} shippingTypesxes - Tipos de Envio
   */
  const getShippingTypes = async (): Promise<IShippingTypes[]> => {
    /** Instancia del Repository
     * @const {ShippingTypesRepository}
     */
    const shippingTypesRepository = ShippingTypesRepository.instance;

    /**
     * Obtiene los Tipos de Envío del back-end a través del Repositorio.
     * @const {AxiosResponse<IShippingTypes[]>}
     */
    const shippingTypes: AxiosResponse<IShippingTypes[]> = await shippingTypesRepository.getShippingTypes();

    /**
     * Si el backend responde con un 204, retorna un arreglo vacío.
     */
    if (shippingTypes.status === 204) {
      return [];
    }

    /**
     * Retorna los Tipos de Envío obtenidos.
     * @returns {IShippingTypes[]}
     */
    return shippingTypes.data;
  };
  /**
   * retorna la funciones del controlador
   */
  return { getShippingTypes };
};

export default ShippingTypesController;
